export async function delay(ms: number, abortController?: AbortController): Promise<void> {
  // Skip the timer: a zero delay still costs a >= 1ms tick. Also covers NaN.
  if (!(ms > 0)) return

  await new Promise((resolve) => {
    const id = setTimeout(resolve, ms)
    abortController?.signal.addEventListener('abort', () => {
      clearTimeout(id)
    })
  })
}
